var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHideDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button/hide devices/default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button/hide-devices/default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(8.000000, 8.000000) rotate(90.000000) translate(-8.000000, -8.000000) "
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#C8DDE7",
    fill: "#E3EDF3",
    transform: "translate(8.000000, 8.000000) scale(1, -1) rotate(90.000000) translate(-8.000000, -8.000000) ",
    cx: 8,
    cy: 8,
    r: 7.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#06749F",
    transform: "translate(9.000000, 8.000000) scale(1, -1) rotate(-270.000000) translate(-9.000000, -8.000000) ",
    points: "9 5 13 11 5 11"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHideDevices);
export default __webpack_public_path__ + "static/media/icon_hide_devices.7a92eab687354dec36ee758a985603fa.svg";
export { ForwardRef as ReactComponent };